import { AuthState } from 'types/store/reducers/auth';
import { AuthActions } from 'types/store/actions/auth';
import { AuthActionTypes } from 'types/store/actions/constants';

const initialState: AuthState = {
  isLoading: false,
  error: '',
  roles: [],
};

export default (state = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case AuthActionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case AuthActionTypes.LOGIN_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case AuthActionTypes.LIST_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload,
      };
    default:
      return state;
  }
};
